    window.addEventListener("load", () => {
      const targetNode = document.querySelector('mini-cart');
      const observerConfig = { characterData: true, attributes: true, attributeOldValue: true, childList: true, subtree: true };
      
      const observer = new MutationObserver((mutations) => { 
        mutations.forEach((mutation) => {
          const { target } = mutation;
          if (mutation.attributeName === 'data-amount') {
          }
          else if (mutation.type === 'childList' && mutation.target.className === 'value price tdf-cart-total-parent tdf-priced'){
            // tdf object has been created-updated            
            if (mutation.addedNodes[1].className === 'tdf_price_normal' ) {
              var tdfMoney = mutation.addedNodes[1].firstChild.dataset.tov; 
              if (tdfMoney) {
                let afterpayDataAmount = document.querySelector('.mini-cart__footer #afterpay_hidden afterpay-placement').getAttribute("data-amount");
                if (afterpayDataAmount) {
                  if (afterpayDataAmount != tdfMoney) {
                    document.querySelector('.mini-cart__footer #afterpay_hidden afterpay-placement').setAttribute("data-amount", tdfMoney);
//                    document.querySelector('.mini-cart__footer #afterpay_hidden').setAttribute("style", "display:inherit;");
                  }
                }
              }
            }
          }
        });
      });
      
      observer.observe(targetNode, observerConfig);
      
    });